import DefaultTheme from 'vitepress/theme'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import About from "./components/About.vue";
import ArticleList from "./components/ArticleList.vue";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './tailwind.postcss'
export default {
    ...DefaultTheme,
    enhanceApp(ctx) {
        DefaultTheme.enhanceApp(ctx)
        ctx.app.use(ElementPlus)
        ctx.app.component('ArticleList', ArticleList)
        // ctx.app.component('start', start)
        ctx.app.component('About', About)
        ctx.app.component("Calendar", ElementPlusIconsVue.Calendar)
        ctx.app.component("Folder", ElementPlusIconsVue.Folder)
        // for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        //     ctx.app.component(key, component)
        // }
    }
}
